import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-result-found',
  templateUrl: './no-result-found.component.html',
  styleUrls: ['./no-result-found.component.css']
})
export class NoResultFoundComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
